import { Component, OnInit } from '@angular/core';
import { IsActiveMatchOptions, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { DialogService, ToastService } from 'shared/ui';
import { NotesDialogComponent, NotificationDialogComponent } from 'user';
import { NotesAPIService, NotificationsAPIService } from 'shared/services';
import { APIService } from 'viewer';
import { NativeEnvironmentService } from '../../services/native-environment.service';
import { lt } from 'semver';

const EXACT_ROUTER_MATCH_OPTION: IsActiveMatchOptions = {
  paths: 'exact',
  queryParams: 'ignored',
  fragment: 'ignored',
  matrixParams: 'ignored',
};

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  public _newNotificationAlertCount = 0;
  public _newMessageAlertCount = 0;
  public _isPurchaseButtonLoading = false;
  public _isApp = false;

  constructor(
    private _router: Router,
    private _dialogService: DialogService,
    private _notesAPIService: NotesAPIService,
    private _notificationsAPIService: NotificationsAPIService,
    private _apiService: APIService,
    private _toastService: ToastService,
    private _nativeEnvironmentService: NativeEnvironmentService
  ) {}

  ngOnInit(): void {
    this._isApp = !!(
      (window as any).webkit?.messageHandlers?.bukHybrid ||
      (window as any).bukAndroid
    );

    this._notificationsAPIService.getNewCount().subscribe((result) => {
      this._newNotificationAlertCount = result.count;
    });

    this._notesAPIService.getNewCount().subscribe((result) => {
      this._newMessageAlertCount = result.count;
    });
  }

  get _isBookshelfPageActive(): boolean {
    return (
      this._router.isActive('/bookshelf', EXACT_ROUTER_MATCH_OPTION) ||
      this._router.isActive('/bookshelf/detail', EXACT_ROUTER_MATCH_OPTION)
    );
  }

  public _onClickNotification(): void {
    this._newNotificationAlertCount = 0;

    this._dialogService.open(NotificationDialogComponent, {
      data: {
        isApp: true,
        serviceOrigin: environment.serviceOrigin,
      },
    });
  }

  public _onClickMessage(): void {
    this._newMessageAlertCount = 0;

    this._dialogService.open(NotesDialogComponent, {
      responsiveBreakpoint: 768,
      data: {
        isViewer: false,
      },
    });
  }

  _onClickPurchaseButton(): void {
    if (this._isPurchaseButtonLoading) {
      return;
    }

    this._isPurchaseButtonLoading = true;

    if (!this._shouldUseAppTokenRedirect()) {
      this._isPurchaseButtonLoading = false;
      window.open(environment.serviceOrigin, '_blank');
      return;
    }

    this._apiService.getAppToken().subscribe({
      next: (result) => {
        const appToken = result.app_token;
        const redirectUrl = `${
          environment.serverOrigin
        }/api/v1/app/redirect?app_token=${encodeURIComponent(
          appToken
        )}&redirect_to=${encodeURIComponent(environment.serviceOrigin)}`;

        this._isPurchaseButtonLoading = false;

        const appWindow = window as Window & {
          bukAndroid?: {
            openBrowser?: (url: string) => void;
          };
          webkit?: {
            messageHandlers?: {
              bukHybrid?: {
                postMessage?: (payload: { type: string; data: string }) => void;
              };
            };
          };
        };
        if (typeof appWindow.bukAndroid?.openBrowser === 'function') {
          appWindow.bukAndroid.openBrowser(redirectUrl); // 분리 호출 X
        } else if (appWindow.webkit?.messageHandlers?.bukHybrid?.postMessage) {
          appWindow.webkit.messageHandlers.bukHybrid.postMessage({
            type: 'openBrowser',
            data: redirectUrl,
          });
        } else {
          window.open(redirectUrl, '_blank');
        }
      },
      error: () => {
        this._isPurchaseButtonLoading = false;
        this._toastService.open('인증에 실패했습니다.');
      },
    });
  }

  private _shouldUseAppTokenRedirect(): boolean {
    if (!this._isApp) {
      return false;
    }

    const appVersion = this._nativeEnvironmentService.version;

    if (!appVersion) {
      return false;
    }

    const minRequiredVersion =
      this._nativeEnvironmentService.os === 'ios'
        ? environment.minRequiredIOSVersion
        : environment.minRequiredAndroidVersion;

    return !lt(appVersion, minRequiredVersion);
  }
}
